import { render } from "./CargaForm.vue?vue&type=template&id=9a4746de&scoped=true"
import script from "./CargaForm.vue?vue&type=script&lang=js"
export * from "./CargaForm.vue?vue&type=script&lang=js"

import "@/assets/css/tabs.css?vue&type=style&index=0&id=9a4746de&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a4746de"]])

export default __exports__